import { errorType, startType } from 'redux-store/constants/action-types';
import auth from 'helpers/auth';
import { API, BASE_URL } from 'CONST'
import { get } from 'helpers/requests'
import {
  CORREDOR_CP_GET_LIST
} from '../../redux-store/constants/action-types';

export const executePromise = (dispatch, object, promise) => {
  dispatch({ type: startType(object.type) });
  return promise
    .then(response => dispatch({ type: object.type, payload: response }))
    .catch((error) => {
      const errorActionType = errorType(object.type);
      try {
        error.json().then(json =>
          dispatch({ type: errorActionType, payload: { error, body: json } })
        );
      } catch {
        dispatch({ type: errorActionType, payload: { error, body: {} } })
      }
    });
};

export const getData = object => (dispatch) => {
  return executePromise(dispatch, object, auth.fetch(object.url));
};

export const postData = object => (dispatch) => {
  return executePromise(dispatch, object, auth.fetch(object.url, {
    method: 'POST',
    body: JSON.stringify(object.config),
    headers: {
      'Content-Type': 'application/json',
    },
  }));
};

export const patchData = object => (dispatch) => {
  return executePromise(dispatch, object, auth.fetch(object.url, {
    method: 'PATCH',
    body: JSON.stringify(object.config),
    headers: {
      'Content-Type': 'application/json',
    },
  }));
};

export const uploadFile = object => (dispatch) => {
  return executePromise(dispatch, object, auth.fetch(object.url, {
    method: 'PUT',
    body: object.config.body,
    headers: {
      'Content-Disposition': `attachment; filename="${encodeURI(object.config.name)}"`,
    },
  }));
};

export const deleteData = object => (dispatch) => {
  dispatch({ type: startType(object.type) });
  return executePromise(dispatch, object,
    auth.fetch(object.url, {
      method: 'DELETE',
      body: '',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(() => dispatch(({ type: object.type, payload: { id: object.id } })))
      .catch((error) => {
        dispatch({ type: errorType(object.type), payload: error });
      })
  );
};

export const getEndosos = (filterParams) => {
  return (dispatch) => {
    dispatch({ type: startType(CORREDOR_CP_GET_LIST) });
    
    get(`${BASE_URL}${API.creditosIntermediarios}/?${filterParams}`)
      .then((response) => {
        
        dispatch({
          type: CORREDOR_CP_GET_LIST,
          payload: response,
        });
      })
      .catch((err) => {
        console.error('Error fetching endosos:', err);
      });
  };
};